// Copyright 2017 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { DelegateFilter, IFilter } from "filters/IFilter";
import { MeasurementDeviceSetup, MeasurementDeviceSetupStub } from "services/Hardware/Datatypes/MeasurementDeviceSetup";

@autoinject
export class MeasurementDeviceSetupFilterFactory {
    public create(
        filterFunction: (setups: MeasurementDeviceSetup | MeasurementDeviceSetupStub) => boolean
    ): IFilter<MeasurementDeviceSetup | MeasurementDeviceSetupStub> {
        return new DelegateFilter<MeasurementDeviceSetup>((item) => Promise.resolve(filterFunction(item)));
    }
}
